@let status = this.status();

@if (type() === 'banner') {
  <div class="item f-body-l f-medium">
    @if (!vehicle()) {
      <ng-container *ngTemplateOutlet="telematicsStatusIcon"></ng-container>

      <p class="f-muted">{{ status.label | translate }}</p>
    } @else if (store.loading()) {
      <onyx-spinner color="black" [size]="16"></onyx-spinner>

      {{ `${I18N}.downloadingTelematicsData` | translate }}
    } @else {
      <div class="information-item-wrapper">
        <div class="content">
          <ng-container *ngTemplateOutlet="telematicsStatusIcon"></ng-container>

          {{ status.label | translate }}
        </div>

        <ng-container *ngTemplateOutlet="telematicsAddons"></ng-container>
      </div>
    }
  </div>
} @else {
  <onyx-icon-box
    [color]="$any(status.color)"
    [hasTransparentBackground]="true"
    [size]="16"
    [gap]="8"
    [isCentered]="true"
  >
    <ng-container icon>
      @if (!vehicle()) {
        <ng-container *ngTemplateOutlet="telematicsStatusIcon"></ng-container>
      } @else if (store.loading()) {
        <onyx-spinner color="black" [size]="16"></onyx-spinner>
      } @else {
        <onyx-icon [name]="status.icon" [size]="16"></onyx-icon>
      }
    </ng-container>

    @if (!vehicle()) {
      {{ status.label | translate }}
    } @else if (store.loading()) {
      {{ `${I18N}.downloadingTelematicsData` | translate }}
    } @else {
      <div class="content">
        {{ status.label | translate }}

        <ng-container *ngTemplateOutlet="telematicsAddons"></ng-container>
      </div>
    }
  </onyx-icon-box>
}

<ng-template #telematicsAddons>
  @if (
    vehicle()?.telematics && telematicsItem()?.status?.offRouteData?.isCritical
  ) {
    <onyx-icon
      class="f-danger"
      name="vehicle-off-route-filled"
      [size]="16"
      onyxTooltip="labels.vehicleOffRoute"
    ></onyx-icon>
  }
</ng-template>

<ng-template #telematicsStatusIcon>
  <onyx-icon
    [class]="[`color-${status.color}`]"
    [name]="status.icon"
    [size]="16"
  ></onyx-icon>
</ng-template>
